module.exports = __webpack_public_path__ + "img/pr-4.40ae1cd3.png";